import React from "react"
import Divider from "semantic-ui-react/dist/es/elements/Divider/Divider"
import Loader from "semantic-ui-react/dist/es/elements/Loader/Loader"

export default class DynamicDropdown extends React.Component {
  constructor(props) {
    super()
    this.state = {
      selectedValue: props.value || null,
      open: false, // controls option 'dropdown' visibility
      highlightedIndex: props.options.indexOf(
        props.options.find(option => option.value === props.value)
      ), // This will be removed once we move options to Promise
      isModalOpen: false,
      searchMode: false,
      searchValue: "",
      isSearchFocused: false,
      loading: false // used when api search is available
    }
    this.options = props.options.slice() // master options
    this.filteredOptions = this.options.slice()
    this.debounceHandle = null
  }

  onClickDropdown = () => {
    this.setState({ open: !this.state.open })
    if (this.props.search) {
      this.setState({ searchMode: !this.state.open, searchValue: "" })
    }
    setTimeout(() => this.scrollSelectedItemIntoView(), 0)
  }

  componentDidUpdate = () => {
    if (this.props.options.length !== this.options.length) {
      this.options = this.props.options.slice()
    }
    if (this.newItemAdded) {
      this.setState(
        {
          selectedValue: this.options[this.options.length - 1].value
        },
        () => {
          this.props.onChange(
            {},
            { value: this.options[this.options.length - 1].value }
          )
        }
      )

      this.newItemAdded = false
    }
  }

  onSelectOption = value => {
    // in remote search if value is not present in options, attach it
    if (
      this.props.remoteSearch &&
      this.options.find(option => option.value === value) === undefined
    ) {
      if (this.options.length > this.props.options.length) {
        // remove the unused extra option
        this.options.pop()
      }
      this.options.push(
        this.filteredOptions.find(option => option.value === value)
      )
    }
    const selectedOptionIndex = this.options.indexOf(
      this.options.find(option => option.value === value)
    )
    this.setState({
      selectedValue: value,
      open: false,
      searchMode: false,
      searchValue: "",
      highlightedIndex: selectedOptionIndex
    })
    // #c1 formContainer needs to be notified. passing empty object as event(as event is not used there)
    this.props.onChange({}, { value })
  }

  changeFocus = focus => {
    if (!focus && this.state.open && !this.state.isSearchFocused) {
      this.setState({ focus, open: false, searchMode: false, searchValue: "" })
      !this.state.isModalOpen && this.props.onBlur({}) // #c1
    } else if (!focus && this.state.isSearchFocused) {
      this.setState({ focus, isSearchFocused: false })
      this.props.onFocus({})
    } else {
      this.setState({ focus })
      this.props.onFocus({}) // #c1
    }
  }

  scrollSelectedItemIntoView = () => {
    const item = this.highlightedItemElement
    if (!item) {
      return
    }
    const menu = this.menuElement
    const isOutOfUpperView = item.offsetTop < menu.scrollTop
    const isOutOfLowerView =
      item.offsetTop + item.clientHeight > menu.scrollTop + menu.clientHeight
    if (isOutOfUpperView) {
      menu.scrollTop = item.offsetTop
    } else if (isOutOfLowerView) {
      menu.scrollTop = item.offsetTop + item.clientHeight - menu.clientHeight
    }
  }

  changeHighlightedIndex = step => {
    let newIndex = 0
    let optionContext =
      this.state.searchMode && this.state.searchValue !== ""
        ? this.filteredOptions
        : this.options
    if (!this.state.open) {
      newIndex = step > 0 ? optionContext.length - 1 : 0
    } else {
      newIndex = this.state.highlightedIndex + step
    }
    if (newIndex < 0) {
      newIndex = optionContext.length
    } else if (newIndex > optionContext.length) {
      newIndex = 0
    }
    if (newIndex <= optionContext.length - 1) {
      setTimeout(() => this.scrollSelectedItemIntoView(), 0)
    }
    this.setState({ highlightedIndex: newIndex, open: true })
  }

  keyHandler = e => {
    let stopPropagation = true
    let preventDefault = false
    switch (e.key) {
      case "ArrowDown": {
        this.changeHighlightedIndex(1)
        preventDefault = true
        break
      }
      case "ArrowUp": {
        this.changeHighlightedIndex(-1)
        preventDefault = true
        break
      }
      case "Enter": {
        let optionContext =
          this.state.searchMode && this.state.searchValue !== ""
            ? this.filteredOptions
            : this.options
        if (this.state.highlightedIndex < optionContext.length) {
          this.onSelectOption(optionContext[this.state.highlightedIndex].value)
        } else {
          this.onOpenModal()
        }
        preventDefault = true
        break
      }
      default: {
        stopPropagation = false
      }
    }
    if (stopPropagation) {
      e.stopPropagation()
    }
    if (preventDefault) {
      e.preventDefault()
    }
  }

  onOpenModal = event => {
    event && event.preventDefault()
    this.setState({ isModalOpen: true })
  }

  onCancel = event => {
    this.setState({ isModalOpen: false })
  }

  submit = async values => {
    await this.props.addSubmit(values)
    this.newItemAdded = true
    this.setState({
      isModalOpen: false
    })
    return true
  }

  setSearchMode = status => {
    this.setState({
      searchMode: status,
      focus: status,
      open: status,
      isSearchFocused: true
    })
    if (!status) {
      this.setState({ searchValue: "" })
    }
  }

  onChangeSearch = searchValue => {
    this.setState({ searchValue })
    if (searchValue !== "" && this.props.remoteSearch) {
      this.setState({
        loading: true,
        searchMode: true,
        open: true,
        focus: true
      })
      if (this.debounceHandle !== null) {
        clearTimeout(this.debounceHandle)
      }
      this.debounceHandle = setTimeout(() => this.performRemoteSearch(), 500)
    } else {
      this.filteredOptions = this.options.filter(option =>
        option.text.toLowerCase().includes(searchValue.toLowerCase())
      )
      this.setState({ searchValue, open: true, focus: true, searchMode: true })
    }
  }

  performRemoteSearch = () => {
    this.props.remoteSearch(this.state.searchValue).then(response => {
      this.filteredOptions = response
        .filter(
          option =>
            (option.text &&
              option.text
                .toLowerCase()
                .includes(this.state.searchValue.toLowerCase())) ||
            (option.name &&
              option.name
                .toLowerCase()
                .includes(this.state.searchValue.toLowerCase()))
        )
        .map(option => {
          return {
            text: option.text ? option.text : option.name,
            value: option.id
          }
        })
      this.setState({ loading: false })
    })
  }

  render() {
    const {
      search,
      addLabel,
      name,
      addSubmit,
      remoteSearch,
      onAddSuccessMap,
      onBlur,
      onChange,
      onFocus,
      options,
      placeholder,
      value,
      modalControl: ModalControl,
      modalProps,
      ...rest
    } = this.props
    let selectedText =
      this.state.selectedValue !== null && !this.state.searchMode
        ? this.options.find(option => option.value === this.state.selectedValue)
            .text
        : ""
    selectedText = search && this.state.searchMode ? "" : selectedText
    let dropDownActive = this.state.focus ? "active" : ""
    let menuStatus = this.state.open ? "transition visible" : ""
    let dropDownClass = search
      ? "ui fluid search selection dropdown"
      : "ui fluid selection dropdown"
    let optionContext =
      this.state.searchMode && this.state.searchValue !== ""
        ? this.filteredOptions
        : this.options
    return (
      <div
        className={`${dropDownClass} ${dropDownActive} `}
        tabIndex={0}
        onClick={this.onClickDropdown}
        onFocus={() => this.changeFocus(true)}
        onBlur={() => this.changeFocus(false)}
        onKeyDown={e => this.keyHandler(e)}
        {...rest}
      >
        <i className="dropdown icon" />
        {search && (
          <input
            onClick={event => this.setSearchMode(true)}
            onChange={event => this.onChangeSearch(event.target.value)}
            className="search"
            tabIndex={0}
            value={this.state.searchValue}
          />
        )}
        <div className="text" name={name}>
          {selectedText}
        </div>
        <div
          ref={element => {
            this.menuElement = element
          }}
          className={`menu ${menuStatus}`}
        >
          {!this.state.loading &&
            optionContext.length === 0 &&
            !!this.state.selectedValue && (
              <div className="item disabled">No matches</div>
            )}
          {this.state.loading && (
            <div className="item disabled">
              <Loader active size="mini" />
              <span className="text">Loading...</span>
            </div>
          )}
          {!this.state.loading &&
            optionContext.map((option, index) => (
              <div
                key={index}
                className={`${
                  this.state.selectedValue === option.value ? "active" : ""
                } ${
                  this.state.highlightedIndex === index ? "selected" : ""
                } item`}
                style={{ pointerEvents: "all" }}
                ref={element => {
                  this.highlightedItemElement =
                    this.state.highlightedIndex === index
                      ? element
                      : this.highlightedItemElement
                }}
                onMouseDown={() => {
                  this.onSelectOption(option.value)
                }}
              >
                <span className="text">{option.text}</span>
              </div>
            ))}
          {ModalControl && <Divider style={{ margin: "0px" }} />}
          {ModalControl && (
            <div
              className={`item active ${
                this.state.highlightedIndex === optionContext.length
                  ? "selected"
                  : ""
              }`}
              style={{ color: "#0caae9" }}
            >
              <div onMouseDown={this.onOpenModal}>{addLabel}</div>
              {this.state.isModalOpen && (
                <ModalControl
                  submit={this.submit}
                  onCancel={this.onCancel}
                  {...modalProps}
                />
              )}
            </div>
          )}
        </div>
      </div>
    )
  }
}

DynamicDropdown.propTypes = {}

DynamicDropdown.defaultProps = {}
